var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loginFooter-wrapper"},[_vm._v("粤ICP备18161349号-1 Copyright © 广州白云金科控股集团有限公司")])
}
var staticRenderFns = []

export { render, staticRenderFns }